<ng-container *ngIf="publicAccessLevel !== 'no_access'">
  <app-editable-gallery-url-field
    [gallery]="gallery"
    [asset]="asset"
    [accessLevel]="'view_only'"
    (onEditingPathChange)="isEditingPath = $event"
  ></app-editable-gallery-url-field>

  <div *ngIf="!loading" class="main-container" [class.disabled]="isEditingPath">
    <div class="access-list-container" *ngIf="gallery.password_enabled">
      <div class="access-list">
        <div class="access-list-item">
          <div class="access-list-icon orange">
            <app-svg src="/assets/icons/lock.svg"></app-svg>
          </div>

          <div class="access-list-info no-overflow-protect">
            <div class="info-main">Password is set</div>
          </div>

          <div class="access-list-action">
            <button
              appButton
              name="copy-password"
              location="share-sub-gallery-link"
              [copy-clipboard]="gallery['password']"
              color="gray-bordered"
              weight="bold"
              size="1"
              height="1"
              (click)="onPasswordCopied()"
            >
              <span>• • • • • Copy</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <app-share-gallery-social-links
      [gallery]="gallery"
      [asset]="asset"
      [disabled]="isEditingPath"
    ></app-share-gallery-social-links>
  </div>
</ng-container>
